var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1437,
    height: 977,
    viewBox: "0 0 1437 977",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_1105)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 913,
    x2: 30,
    y2: -57,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1195,
    y1: 713,
    x2: 1195,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131,
    y1: 813,
    x2: 131,
    y2: 4,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1295,
    y1: 813,
    x2: 1295,
    y2: 4,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231,
    y1: 713,
    x2: 231,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1395,
    y1: 913,
    x2: 1395,
    y2: -57,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303,
    y1: 713,
    x2: 303,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375,
    y1: 713,
    x2: 375,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447,
    y1: 713,
    x2: 447,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 519,
    y1: 713,
    x2: 519,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591,
    y1: 713,
    x2: 591,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 713,
    x2: 663,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 735,
    y1: 713,
    x2: 735,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 807,
    y1: 713,
    x2: 807,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 879,
    y1: 713,
    x2: 879,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 951,
    y1: 713,
    x2: 951,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 951,
    y1: 713,
    x2: 951,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1023,
    y1: 713,
    x2: 1023,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1095,
    y1: 713,
    x2: 1095,
    y2: 64,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 64.5L-0.5 -75",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 136.5L-10.5 17.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 208.5L-7 109",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 280.5L-7 210",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 352.5H-7.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447 964.5L1194.5 712",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.5 806L1194.5 640",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 673L1194.5 568",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448.5 555.5L1195.5 497",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.5 970.5L1094.5 712",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123 956L1022.5 712",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998 958.5L951.5 712",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894 955L878.5 713",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.5 951.5L230.5 713",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18 833L230.5 641",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 719L230.5 569",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 617L230.5 497",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.5 497.5L230.5 425",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 957.5L303.5 712",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 953L375.5 712",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5 967L447 713",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5 953L519.5 712",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 967L590 713",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537 954L661.5 713",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.5 954L735 713",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.5 962L807.5 712",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 64.5L126 -75",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5 64.5L239.5 -74",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5 65.5L316.5 -73",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.5 65.5L431.5 -76",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.5 65.5L520 -75.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.5 64.5L1426 -75",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.5 136.5L1452 -18.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.5 208.5L1442.5 89.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.5 280.5L1442.5 185.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.5 352.5L1442 288.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195 424L1440.5 399.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.5 64.5L1326 -75",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.5 64.5L1223 -84.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.5 64.5L1156.5 -94",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.5 64.5L1064 -89",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.5 64.5L940 -88",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.5 64.5L804.5 -80",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.5 68.5V-71.5",
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 64.5,
    x2: 1195.5,
    y2: 64.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.5,
    y1: 4.5,
    x2: 1293.5,
    y2: 4.5001,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 136.5,
    x2: 1195.5,
    y2: 136.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 208.5,
    x2: 1195.5,
    y2: 208.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 280.5,
    x2: 1195.5,
    y2: 280.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 352.5,
    x2: 1195.5,
    y2: 352.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 424.5,
    x2: 1195.5,
    y2: 424.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 496.5,
    x2: 1195.5,
    y2: 496.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 568.5,
    x2: 1195.5,
    y2: 568.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 640.5,
    x2: 1195.5,
    y2: 640.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 712.5,
    x2: 1195.5,
    y2: 712.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.5,
    y1: 812.5,
    x2: 1295.5,
    y2: 812.5,
    stroke: "#43488D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 912.5,
    x2: 1395.5,
    y2: 912.5,
    stroke: "#43488D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_1105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1437,
    height: 977,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGrid);
export default __webpack_public_path__ + "static/media/Hero Grid.2a5669a95f55f03d8dd6e712ef4eef56.svg";
export { ForwardRef as ReactComponent };